import { createFileRoute } from '@tanstack/react-router';
import { WomanEditor } from '../../app/components/woman/woman-editor';

export const Route = createFileRoute('/women/$womanId')({
  component: WomanEditorRoute,
});

// A full page (not a modal): the parent route (`women.tsx`) renders only this
// while it is open. Permissions are checked by the parent's ProtectedRoute.
function WomanEditorRoute() {
  const { womanId } = Route.useParams();
  // key: opening another woman starts from a clean editor.
  return <WomanEditor key={womanId} womanId={womanId} />;
}
